export const environment = {
  apiUrl: window.location.hostname.includes('xilo-dev')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-review-app')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-staging')
    ? 'https://xilo-staging-api.herokuapp.com/api/'
    : window.location.hostname.includes('xilo.io')
    ? 'https://api.xilo.io/api/'
    : 'http://localhost:3000/api/',
  customerFormUrl: window.location.hostname.includes('localhost')
    ? 'http://localhost:4200'
    : window.location.hostname.includes('xilo-dev')
    ? 'http://xilo-dev-customer-form.herokuapp.com'
    : 'https://forms.xilo.io',
  intakeFormUrl: window.location.hostname.includes('localhost')
    ? 'http://localhost:4300'
    : window.location.hostname.includes('xilo-dev')
    ? 'http://xilo-dev-intake-form.herokuapp.com'
    : 'https://intake.xilo.io',
  quoteApiUrl: window.location.hostname.includes('localhost')
    ? // ? 'http://localhost:3001'
      'https://dev.api.xilo.io'
    : 'https://dev.api.xilo.io',
  workflowsApiUrl: window.location.hostname.includes('localhost')
    ? 'http://localhost:3333/api'
    : window.location.hostname.includes('xilo-dev')
    ? 'https://workflows-api-dev.xilo.io/api'
    : 'https://workflows-api.xilo.io/api',
  dashboardUrl: window.location.hostname.includes('localhost')
    ? 'http://localhost:4100'
    : window.location.hostname.includes('xilo-dev')
    ? 'https://xilo-dev-dashboard.xilo.io'
    : 'https://dashboard.xilo.io',
  applicationApiUrl: window.location.hostname.includes('localhost')
    ? 'http://localhost:3400/api'
    : window.location.hostname.includes('xilo-dev')
    ? 'https://api-dev.xilo.io/api'
    : 'https://api.xilo.io/api'
};

